import { LeadEventType } from "../shared/types";

export const SMARTHOME_ACTIONS = ["createLead", "postEvent", "changeUserAssigned"] as const;

export type SmarthomeAction = (typeof SMARTHOME_ACTIONS)[number];

export type SmarthomeEventMapping = {
  event: LeadEventType;
  createLead?: {
    projectId: string;
    stageId: string;
    origin?: string;
    comment: string;
    postEvent?: {
      eventContent: string;
      userId: string;
    };
    changeUserAssigned?: {
      transferCategories?: Record<string, string>;
      defaultUserId?: string;
    };
  };
  postEvent?: {
    eventContent: string;
    userId: string;
  };
  changeUserAssigned?: Record<string, string>;
};

export const isSmarthomeEventMapping = (mapping: unknown): mapping is SmarthomeEventMapping => {
  return (
    typeof mapping === "object" &&
    mapping !== null &&
    ("createLead" in mapping || "postEvent" in mapping || "changeUserAssigned" in mapping)
  );
};

export const getSmarthomeActionLabel = (action: SmarthomeAction): string => {
  const labels: Record<SmarthomeAction, string> = {
    createLead: "Crear Lead",
    postEvent: "Post Event",
    changeUserAssigned: "Cambiar usuario asignado",
  };
  return labels[action] || action;
};
